import React, { useState, useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Button from '@vtex/styleguide/lib/Button'

import { ICON_SIZE } from '@/checkout-instore-legacy/constants/SizeConstants'
import Icon from '@/checkout-instore-legacy/components/Commons/Icons'
import { printTextRemoteDevice } from '@/checkout-instore-legacy/utils/printUtils'

const PrintReceipt = ({ labelId, receipt, automaticallyPrintReceipt }) => {
  const [isLoading, setLoading] = useState(false)

  const handleClick = useCallback(() => {
    setLoading(true)
    printTextRemoteDevice(receipt).finally(() => setLoading(false))
  }, [receipt])

  useEffect(() => {
    if (automaticallyPrintReceipt) {
      handleClick()
    }
  }, [automaticallyPrintReceipt, handleClick])

  return (
    <Button
      variation="tertiary"
      size="small"
      onClick={handleClick}
      isLoading={isLoading}
      collapseLeft
    >
      <Icon type="nc-print" color="currentColor" size={ICON_SIZE} />
      <span className="ttu ml3">
        <FormattedMessage id={labelId} />
      </span>
    </Button>
  )
}

PrintReceipt.defaultProps = {
  automaticallyPrintReceipt: false,
}

PrintReceipt.propTypes = {
  labelId: PropTypes.string.isRequired,
  receipt: PropTypes.string.isRequired,
  automaticallyPrintReceipt: PropTypes.bool,
}

export default PrintReceipt
